import React, { FC } from "react";
import cn from "clsx";

import "./style.scss";

interface Props extends React.HTMLAttributes<HTMLElement> {
  element?: keyof HTMLElementTagNameMap;
}

const ViewWrapper: FC<Props> = ({ element, ...rest }) => {
  const Tag = (element || "div") as React.ElementType;
  return <Tag {...rest} />;
};

const View: {
  desktop: FC<Props>;
  mobile: FC<Props>;
} = {
  desktop: ({ className, ...props }) => (
    <ViewWrapper {...props} className={cn("d-none-mobile", className)} />
  ),
  mobile: ({ className, ...props }) => (
    <ViewWrapper {...props} className={cn("d-none-desktop", className)} />
  )
};

export default View;
